import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dlm',
  templateUrl: './dlm.component.html',
  styleUrls: ['./dlm.component.scss']
})
export class DlmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
